<div class="modal-header p-4">
    <h2 class="modal-title">Configuración de guías masivas</h2>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<div class="modal-body p-4 scrollable-modal-body">
        <p>Por favor, selecciona a los proveedores y paqueterías que deseas utilizar para la compra masiva de guías, así como la configuración de su validación, de entre las opciones disponibles para tu compañía.</p>
        <form autocomplete="off" [formGroup]="formBulk" (ngSubmit)="ruSure()" class="mt-3" id="formBulk" >

                <div class="row mt-2">
                    <div class="col-sm-6 reduce-space">
                        <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Proveedores&nbsp;&nbsp;&nbsp;</mat-label>
                        <mat-select formControlName="bulkProviders" multiple>
                            <mat-option *ngFor="let p of providersList" [value]="p.id">{{p.provider}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 reduce-space">
                        <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Paqueterías&nbsp;&nbsp;&nbsp;</mat-label>
                        <mat-select formControlName="bulkCarriers" multiple>
                            <mat-option *ngFor="let c of carriersListFiltered" [value]="c.id">{{c.carrier}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <!-- mat divider--> 
                <mat-divider></mat-divider><br>
                <h4>Configuración</h4><br>

                <div style="margin-bottom: 10px;">Detener proceso de compra por:</div>
                <div class="col-sm-6 d-flex gap-3">
                <div class="d-flex flex-column align-items-start">
                    <div>Reintentos por guía</div>
                    <mat-slide-toggle formControlName="guide_attempts_active" matTooltip="Re-intentos por guía" [matTooltipPosition]="'above'" color="primary" labelPosition="before" style="margin-right: 10px;"></mat-slide-toggle>
                </div>
                <div class="d-flex flex-column align-items-start">
                    <div>Compras fallidas</div>
                    <mat-slide-toggle formControlName="group_attempts_active" matTooltip="Compras fallidas" [matTooltipPosition]="'above'" color="primary" labelPosition="before"></mat-slide-toggle>
                </div>
                </div><br>

                <div class="row mt-2">
                    <div class="col-sm-6 reduce-space">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Reintentos por guía (máximo 5)</mat-label>
                            <input matInput type="number" formControlName="guide_attempts">
                        </mat-form-field>
                        <small>Número de intentos con la tarifa más barata antes de probar otras. Si está activada la opción para detener el proceso por reintentos por guía, el proceso se detendrá al superar este límite.</small>
                    </div>
                    <div class="col-sm-6 reduce-space">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Compras fallidas por grupo (máximo 10)</mat-label>
                            <input matInput type="number" formControlName="group_attempts">
                        </mat-form-field>
                        <small>Límite de fallas permitidas en un lote. Solo aplica si está activada la opción para detener el proceso por compras fallidas.</small>
                    </div>
                </div>       
                
                <br><mat-divider></mat-divider><br>
                <h5>Actualizar configuración para futuras cargas</h5>
                <div class="d-flex flex-column align-items-start">
                    <mat-slide-toggle formControlName="upd_on_general_config" matTooltip="Actualizar configuración para futuras cargas" [matTooltipPosition]="'above'" color="primary" labelPosition="before" style="margin-right: 10px;"></mat-slide-toggle>
                </div>
    </form>
    <p class="mb-4"></p>
</div>

<div class="modal-footer justify-content-end px-4 pb-4">
    <button mat-flat-button (click)="resetForm()">Limpiar <mat-icon>delete_outline</mat-icon></button>
    <button mat-flat-button class="bg-success text-white" form="formBulk" type="submit">Guardar <mat-icon>save</mat-icon></button>
</div>